module.exports = __webpack_public_path__ + "img/coaching_active.5f62ae77.svg";